// extracted by mini-css-extract-plugin
module.exports = {"FooterLinkGroup":"Footer_FooterLinkGroup__r7vtx","FooterTitle":"Footer_FooterTitle__bqatX"};